import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Card,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import "./ChequeBookFormRequest.css"; // Import the CSS file

// Styles using makeStyles
const useStyles = makeStyles((theme) => ({
  root2: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  marginTop:"10px",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px",
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2),
    },
  },
  inputField: {
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
  },
  buttonRoot: {
    "& > *": {
      margin: theme.spacing(1),
      backgroundColor: "blue",
      color: "white",
    },
  },
}));

export default function ChequeBookFormRequest(props) {
  const classes = useStyles();
  const [isReadOnly, setIsReadOnly] = React.useState(true);
  const [isShow, setIsShow] = React.useState(true);
  const [isShowSubmit, setIsShowSubmit] = React.useState(false);
  const [isShowErrorMsg, setIsShowErrorMsg] = React.useState(false);

  let userData;
  let res_desc;
  let Post_Code;

  // Extracting data from props
  props.cbrFormData.map((item) => {
    res_desc = item.metaData.status.desc;
    userData = item.Body.Payload;
    Post_Code =
      userData.Post_Code.length === 8
        ? userData.Post_Code.substring(2)
        : userData.Post_Code;
  });

  // Initial user data
  const initialUserData = {
    name: userData.Name1,
    Account_Number: userData.Account_Number,
    Leaves_per_book: 20,
    Address1: userData.Address1,
    Address2: userData.Address2,
    Address3: userData.Address3,
    Pin_Code: Post_Code,
  };

  const [userValues, setUserValues] = React.useState(initialUserData);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // PIN Code Validation (only 6 digits allowed)
    if (name === "Pin_Code") {
      if (/^\d{0,6}$/.test(value)) {
        setUserValues({ ...userValues, [name]: value });
      }
      setIsShowErrorMsg(value.length !== 6);
    } else {
      setUserValues({
        ...userValues,
        [name]: value,
      });
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    props.onSendChequeBookFormData(userValues);

    // Disable the input fields after submission
    setIsReadOnly(true);
    setIsShow(false);
    setIsShowSubmit(false);
  };

  return (
    <div
      className="ms-wrapper ms-wrapper-bot ms-wrapper-border ms-width-70"
      style={{ border: "8px solid rgba(244, 176, 53, 0.8)" }}
    >
      <Box>
        <Typography
          align="center"
          variant="subtitle2"
          display="block"
          style={{
            color: "rgba(12, 77, 162, 1)",
            fontSize: "18px",
            textAlign: "center",
            fontWeight: "600",
          }}
        >
          Cheque Book Form
        </Typography>
      </Box>
      <form className={classes.root2} onSubmit={handleSubmit}>
        <Card style={{padding:"10px"}}>
          <Grid>
            {/* Account Holder Name */}
            <TextField
              className={classes.inputField}
              label="Account Holder Name"
              name="name"
              value={userValues.name}
              InputProps={{
                readOnly: true,
              }}
            />

            {/* Account Number */}
            <TextField
              className={classes.inputField}
              label="Account Number"
              name="Account_Number"
              value={userValues.Account_Number}
              InputProps={{
                readOnly: true,
              }}
            />

            {/* Number of Cheque Leaves */}
            <TextField
              className={classes.inputField}
              label="Number of Cheque Leaves"
              name="Leaves_per_book"
              value={userValues.Leaves_per_book}
              InputProps={{
                readOnly: true,
              }}
            />

            {/* Address 1 */}
            <TextField
              className={classes.inputField}
              label="Address 1"
              name="Address1"
              value={userValues.Address1}
              InputProps={{ readOnly: isReadOnly }}
              onChange={handleInputChange}
            />

            {/* Address 2 */}
            <TextField
              className={classes.inputField}
              label="Address 2"
              name="Address2"
              value={userValues.Address2}
              InputProps={{ readOnly: isReadOnly }}
              onChange={handleInputChange}
            />

            {/* Address 3 */}
            <TextField
              className={classes.inputField}
              label="Address 3"
              name="Address3"
              value={userValues.Address3}
              InputProps={{ readOnly: isReadOnly }}
              onChange={handleInputChange}
            />

            {/* PIN Code */}
            <TextField
              className={classes.inputField}
              type="number"
              label="PIN Code"
              name="Pin_Code"
              value={userValues.Pin_Code}
              InputProps={{ readOnly: isReadOnly }}
              onChange={handleInputChange}
              helperText={isShowErrorMsg ? "Only 6 digits are allowed" : null}
              error={isShowErrorMsg}
            />
          </Grid>

          {/* Edit Option */}
          {isShow && (
            <Box>
              <Typography component="subtitle1">
                Do You Want To Modify Your Address and the PIN Code?
              </Typography>
              <Grid container justifyContent="center">
                <Button
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsReadOnly(false);
                    setIsShow(false);
                    setIsShowSubmit(true);
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsShow(false);
                    setIsShowSubmit(true);
                  }}
                >
                  No
                </Button>
              </Grid>
            </Box>
          )}

          {/* Submit Option */}
          {isShowSubmit && (
            <Box>
              <Typography align="center" variant="overline" display="block">
                *Charges as applicable will be levied.
              </Typography>
              <Grid container justifyContent="center">
                <Button
                  type="submit"
                  variant="outlined"
                  size="small"
                  color="primary"
                  disabled={isShowErrorMsg}
                >
                  Submit
                </Button>
              </Grid>
            </Box>
          )}
        </Card>
      </form>
    </div>
  );
}
